import React from 'react'
import '../guia-de-estilos.css'

const Botones = () => {
  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Botones</p>
          </div>
          <div className='row mt-3 row-gap-3'>
            <div className='col-12 col-md-4 text-premium-blue'>
              <p className='sub-title text-center'>.btn-amc-pink</p>
              <div className='p-3'>
                <div className='d-flex justify-content-center'>
                  <button className='btn-amc-md btn-amc-pink'>Default</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-pink'>Hover</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-disabled'>Deshabilitado</button>
                </div>
              </div>
            </div> 
            <div className='col-12 col-md-4 text-premium-blue'>
              <p className='sub-title text-center'>.btn-amc-blue</p>
              <div className='p-3'>
                <div className='d-flex justify-content-center'>
                  <button className='btn-amc-md btn-amc-blue'>Default</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-blue'>Hover</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-disabled'>Deshabilitado</button>
                </div>
              </div>
            </div> 
            <div className='col-12 col-md-4 text-premium-blue'>
              <p className='sub-title text-center'>.btn-amc-turq</p>
              <div className='p-3'>
                <div className='d-flex justify-content-center'>
                  <button className='btn-amc-md btn-amc-turq'>Default</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-turq'>Hover</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-disabled'>Deshabilitado</button>
                </div>
              </div>
            </div>
          </div>
          <div className='row mt-3 row-gap-3'>
            <div className='col-12 col-md-4 text-premium-blue'>
              <p className='sub-title text-center'>.btn-pink-secondary</p>
              <div className='p-3'>
                <div className='d-flex justify-content-center'>
                  <button className='btn-amc-md btn-pink-secondary'>Default</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-pink bg-mexican-pink'>Hover</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-disabled'>Deshabilitado</button>
                </div>
              </div>
            </div>        
            <div className='col-12 col-md-4 text-premium-blue'>
              <p className='sub-title text-center'>.btn-blue-secondary</p>
              <div className='p-3'>
                <div className='d-flex justify-content-center'>
                  <button className='btn-amc-md btn-blue-secondary'>Default</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-pink bg-mexican-pink'>Hover</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-disabled'>Deshabilitado</button>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-4 text-premium-blue'>
              <p className='sub-title text-center'>.btn-white-secondary</p>
              <div className='bg-consistency-blue p-3'>
                <div className='d-flex justify-content-center'>
                  <button className='btn-amc-md btn-white-secondary'>Default</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-pink bg-mexican-pink'>Hover</button>
                </div>
                <div className='d-flex justify-content-center'>
                  <button className='btn-disabled'>Deshabilitado</button>
                </div>
              </div>
            </div>        
          </div>
        </div>
      </div>
    </div>
  )
}

export default Botones